module.exports = __webpack_public_path__ + "static/media/youtube.4be2b3f2.svg";